<template>
  <iframe :src="iframeSrc"></iframe>
</template>

<script>
export default {
  props: {
    src: String
  },
  data() {
    return {
      iframeSrc: ''
    }
  },
  mounted() {
    this.iframeSrc = this.src;
  }
}
</script>

<style scoped>
  iframe {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: none;
  }
</style>